import { createSlice } from "@reduxjs/toolkit";
import { postRequest } from "../../services/apiCaller/cl_index";
import { endpoints } from "../../api/ApiEndPoints";
import { getUpdateLoyalty } from "../signIn/cl_SignInSlice";
import { trackEvent } from "../../services/helper/cl_Helper";
import { trackSignUpEvent } from "../../service/gtag";

const initialState = {
    phoneNumber: "",
    age: "",
    signupSuccess: false,
    errorMessage: "",
    phoneError: false,
    otpError: "",
    pinError: false,
    otpSuccess: false,
    otp: "",
    resendOtp: false,
    fullName: "",
    pin: "",
    confirmPin: "",
    signUpfinish: false,
    loader: false,
    mobileLoader: false,
    referralCode: "",
    countryCode: "",
    token: "",
    phoneNumberChange: false,
    labelCheck: true,
    otpLoader: false,
    isSideMenuOpened: false,
    affiliateCode: "",
    prevPath: false,
    searchUserName: ""
};

export const signUpSlice = createSlice({
    name: "signup",
    initialState,
    reducers: {
        setPhoneNumber: (state, action) => {
            state.phoneNumber = action.payload;
        },
        setPrevPath: (state, action) => {
            state.prevPath = action.payload;
        },
        setToken: (state, action) => {
            state.token = action.payload;
        },
        setAge: (state, action) => {
            state.age = action.payload;
        },
        setSignupSuccess: (state, action) => {
            state.signupSuccess = action.payload;
        },
        setErrorMessage: (state, action) => {
            state.errorMessage = action.payload;
        },
        setEmailError: (state, action) => {
            state.emailError = action.payload;
        },
        setPhoneError: (state, action) => {
            state.phoneError = action.payload;
        },
        setOtpError: (state, action) => {
            state.otpError = action.payload;
        },
        setPinError: (state, action) => {
            state.pinError = action.payload;
        },
        setOtpSuccess: (state, action) => {
            state.otpSuccess = action.payload;
        },
        setResendOtp: (state, action) => {
            state.resendOtp = action.payload;
        },
        setFullName: (state, action) => {
            state.fullName = action.payload;
        },
        setPin: (state, action) => {
            state.pin = action.payload;
        },
        setConfirmPin: (state, action) => {
            state.confirmPin = action.payload;
        },
        setSignUpfinish: (state, action) => {
            state.signUpfinish = action.payload;
        },
        setLoader: (state, action) => {
            state.loader = action.payload;
        },
        setOtpLoader: (state, action) => {
            state.otpLoader = action.payload;
        },
        setMobileLoader: (state, action) => {
            state.mobileLoader = action.payload;
        },
        setReferralCode: (state, action) => {
            state.referralCode = action.payload;
        },
        setPhoneNumberChange: (state, action) => {
            state.phoneNumberChange = action.payload;
        },
        setOtp: (state, action) => {
            state.otp = action.payload;
        },
        setLabelCheck: (state, action) => {
            state.labelCheck = action.payload;
        },
        setIsSideMenuOpened: (state, action) => {
            state.isSideMenuOpened = action.payload;
        },
        setAffiliateCode: (state, action) => {
            state.affiliateCode = action.payload;
        },
        setSearchUserName: (state, action) => {
            state.searchUserName = action.payload;
        },
    }
});

export const {
    setPhoneNumber,
    setCountryCode,
    setSignupSuccess,
    setErrorMessage,
    setOtpSuccess,
    setPin,
    setConfirmPin,
    setSignUpfinish,
    setPhoneError,
    setOtpError,
    setPinError,
    setOtp,
    setLoader,
    setMobileLoader,
    setResendOtp,
    setReferralCode,
    setToken,
    setLabelCheck,
    setPhoneNumberChange,
    setAge,
    setOtpLoader,
    setIsSideMenuOpened,
    setAffiliateCode,
    setPrevPath,
    setSearchUserName
} = signUpSlice.actions;

export default signUpSlice.reducer;

export const handleRegisterOtp = (mobNum) => (dispatch) => {
    let phoneNum = mobNum;
    if (mobNum[0] === "0") {
        phoneNum = mobNum.slice(1);
    }
    let url = endpoints?.registerOtp;
    dispatch(setLoader(true));
    const payload = {
        "channelType": "mobile",
        "mobileNumber": phoneNum,
    };
    postRequest(url, payload)
        .then((res) => {
            if (res?.data?.code === "1000") {
                dispatch(setOtpSuccess(true));
                dispatch(setLoader(false));
                dispatch(setToken(res?.data?.result?.data?.token));
                dispatch(setPhoneNumber(mobNum));
                trackEvent('User', 'Otp', 'Requsted');
            } else {
                dispatch(setOtpSuccess(false));
                if (res?.data?.result?.message === "USER_ALREADY_EXIST") {
                    dispatch(setErrorMessage('The mobile number already exists please login'))
                } else {
                    dispatch(setErrorMessage(res?.data?.result?.message))
                }
                dispatch(setLoader(false));
            }
        })
}

export const signUp = (otp, mobNum, pin, token, labelCheck, referralCode, affiliateCode) => (dispatch) => {
    dispatch(setOtpLoader(true));

    function getGtagClientAndSession() {
  const gaCookie = document.cookie.split('; ').find(c => c.startsWith('_ga='));
  const ga4Cookie = document.cookie.split('; ').find(c => c.startsWith('_ga_'));

  let clientId = null;
  let sessionId = null;

  if (gaCookie) {
    const parts = gaCookie.split('.');
    clientId = parts[parts.length - 1];
  }

  // if (ga4Cookie) {
  //   const parts = ga4Cookie.split('.');
  //   sessionId = parts[2]; // timestamp = session start
  // }

  // sessionId = Number(Date.now().toString());
 sessionId = Number(localStorage.getItem('sessionId'));

  return { clientId, sessionId };
}

    let url = endpoints?.verifySignUp;
    let phoneNum = mobNum;
    if (mobNum[0] === "0") {
        phoneNum = mobNum.slice(1);
    }
    const affiliateCodeData = JSON.parse(localStorage.getItem("affiliateCodeData"));
    const payload = {
        "clientType": "mobile",
        "mobileNumber": phoneNum,
        "otp": otp,
        "password": pin,
        "termsAndConditions": labelCheck,
        "token": token,
        "referalCode": referralCode,
        "affiliateBtag": affiliateCode ? affiliateCode : affiliateCodeData?.afid,
        "campaignId": affiliateCodeData?.cid,
        "channelId": affiliateCodeData?.chid,
        "clientId": getGtagClientAndSession().clientId,
        "sessionId": getGtagClientAndSession().sessionId + ""
    };

    postRequest(url, payload)
        .then((res) => {
            if (res?.data?.code === "1000") {
                dispatch(setSignupSuccess(true));
                dispatch(setOtpSuccess(false));
                dispatch(setOtpError(false));
                dispatch(setOtpLoader(false));
                dispatch(setToken(res?.data?.result?.data?.token));
                dispatch(getUpdateLoyalty(res?.data?.result?.data?.userId));
                trackEvent('User', 'Singup', 'Completed');
                trackSignUpEvent(res?.data?.result?.data?.phoneNumber, 'mobile');
                localStorage.removeItem("affiliateCodeData");
            } else {
                dispatch(setErrorMessage(res?.data?.message));
                dispatch(setOtpSuccess(true));
                dispatch(setOtpError(res?.data?.result?.message));
                dispatch(setOtpLoader(false));
                dispatch(setSignupSuccess(false));
            }
        })
}